import { type Frame, type Layer,rowX, smoothstep } from "./core";

const TOP = 150;
const DROP = 150;
/** Where the ripple is heading: costs sliding down across the row. */
const baseline = (u: number) => TOP + smoothstep(u) * DROP;

/** Energy price −25%: a ripple whose swing keeps REDUCING onto a falling baseline. */
export const Reduction: Layer = Object.assign(() => null, {
  shape: (u: number) => ({
    x: rowX(u),
    y: baseline(u) + Math.sin(u * Math.PI * 5) * 66 * (1 - u),
  }),
  offsetY: (u: number, y: number, f: Frame) => (baseline(u) - y) * (1 - f.settle) * 0.85,
});
